import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import heroMobileImage from '../../images/articles/wf-isf-perspectives-electric-vehicles_767x577.jpg';
import heroDesktopImage from '../../images/articles/wf-isf-perspectives-electric-vehicles_1164x584.jpg';

import bodyDesktopImage from '../../images/articles/wf-isf-expanded-goals-body1-desktop.jpg';
import bodyMobileImage from '../../images/articles/wf-isf-expanded-goals-body1-mobile.jpg';

import ModalOverlay from "../../components/ModalOverlay";

import EVShareMobile from '../../images/articles/EV-share-mobile.png';
import EVRangeMobile from '../../images/articles/EV-range-mobile.png';

import { fireTag } from '../../libs/analytics.js';

const EV = ({
				handleEvent,
				modalOverlay,
				closeExitOverlay,
				addExitClickListeners,
			}) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'wf-isf-perspectives-electric-vehicles_ogimage.jpg';

	addExitClickListeners();

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				fireTag("A2",disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}


	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();

	}, []); // empty array says only use this effect once

	let mastheadImage;
	let bodyImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			bodyImage = bodyMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
	}
	// console.log(mastheadImage);
	// console.log(process.env.PUBLIC_URL);

	return (
		<>
			<Helmet>
				<title>Electric vehicles veer into the fast lane</title>
				<meta
					name="description"
					content="How increased consumer demand is driving growth in clean transportation."
				/>
				<meta property="og:title" content="Electric vehicles veer into the fast lane"/>
				<meta
					property="og:description"
					content="How increased consumer demand is driving growth in clean transportation."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Electric vehicles veer into the fast lane"/>
				<meta
					property="twitter:description"
					content="How increased consumer demand is driving growth in clean transportation."
				/>
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}

			<main className='flex-container article-4'>

				<div className="flex-row">
					{/*flex-col-md-8*/}
					<div className="flex-col-sm-12 headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
							Electric vehicles veer into the fast lane
						</h1>
						<h2 className="summary">
							How increased consumer demand is driving growth in clean transportation.
						</h2>
					</div>

				</div>

				<div className="flex-row full-width exception goals">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="A man plugs a charger into his electric vehicle while looking at his mobile phone."/>
					</div>
				</div>

				<div className="flex-row">


					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>By Jeffrey Schub, <span>sustainable finance integration leader at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>September 12, 2023</p>
							</div>
							<div>
								<p>5-minute read</p>
							</div>
						</div>
						<p>More and more car buyers are warming up to electric vehicles (EVs). A national <a onClick={()=>fireTag('A1','survey')} target="_blank" href="https://info.oregon.aaa.com/aaa-research-25-of-americans-say-theyd-buy-an-ev-for-their-next-auto-purchase/" rel="noreferrer" data-click-listener="true">survey</a> by the auto club group AAA shows a quarter of consumers plan to go fully electric for their next vehicle purchase. The most common reason to switch from a gas-powered vehicle to an electric one is to save on fuel costs.
						</p>

						<p>
							<strong>Sales surge:</strong> In the U.S., EV sales continue to climb. Last year, EVs made up nearly 8% of new vehicle sales — more than tripling their share in two years. This boost occurred before the implementation of the Inflation Reduction Act (IRA) at the start of 2023, which will further incentivize EV purchases with tax credits.
						</p>
						<ul className="copy-list">
							<li>
								Share of new EVs sold: 4.5% in 2021 and 7.7% in 2022.
							</li>
							<li>
								Number of <a onClick={()=>fireTag('A1','new evs')} target="_blank" href="https://www.iea.org/data-and-statistics/data-tools/global-ev-data-explorer" rel="noreferrer" data-click-listener="true">new EVs</a> sold: 630,000 in 2021 and 990,000 in 2022.
							</li>
						</ul>
						<div className="flex-row full-width exception">
							<div className="flex-row text-center">
								<div className="flex-col-md-12 flex-col-sm-12 text-center content-box" style={{maxWidth: '928px', marginLeft: 'auto', marginRight: 'auto',}}>
									<div className="content-header bulleted">
										<h2 className="content-title bulleted">Share of new U.S. EV sales (2010 – 2022)</h2>
									</div>

									<div className="inner-content bulleted">
										<div className="content single chart-title">
											{/*<p className="content-subtitle bulleted">Share of new cars sold that are electric</p>*/}
											{/*<p className="content-undersubtitle bulleted">Electric cars include both battery-electric and plug-in hybrids.</p>*/}
											<p className="content-subtitle bulleted">Electric cars include both battery-electric and plug-in hybrids.</p>
										</div>

										<div className="content">
											<div id="event-tiles">
												<img className="tile tile1" src={EVShareMobile} alt="A bar graph showing increasing sales of new electric vehicles in USA from 2010 to 2022." aria-label="A bar graph showing increasing sales of new electric vehicles in USA from 2010 to 2022."/>
											</div>
											<div className="source">
												<p>Source: <a onClick={()=>fireTag('A1', 'international energy agency/hannah ritchie')} target="_blank" href="https://hannahritchie.com/ev-data-explorer/" rel="noreferrer" data-click-listener="true">International Energy Agency/Hannah Ritchie</a></p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


				</div>


				<div className="flex-row">
					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro" style={{paddingTop: 0}}>


						<p><strong>More options with longer range:</strong> As automakers expand their <a onClick={()=>fireTag('A1', 'ev production')} target="_blank" href="https://www.consumerreports.org/cars/hybrids-evs/why-electric-cars-may-soon-flood-the-us-market-a9006292675/" rel="noreferrer" data-click-listener="true">EV production</a>, consumers have more models to choose from with longer driving ranges.</p>

						<p>
							In the past, many consumers worried that an EV’s <a onClick={()=>fireTag('A1', 'battery charge')} target="_blank" href="https://www.autolist.com/news-and-analysis/2021-survey-electric-vehicles" rel="noreferrer" data-click-listener="true">battery charge</a> could limit their range, preventing long-distance travel. With advancements in battery technology, <a onClick={()=>fireTag('A1', 'range capabilities')} target="_blank" href="http://hannahritchie.com/chart-ev-range/" rel="noreferrer" data-click-listener="true">range capabilities</a> have significantly improved. Many EV models can now travel more than 200 miles on a single charge.
						</p>
					</div>
				</div>

				<div className="flex-row full-width exception">
					<div className="flex-row text-center">
						<div className="flex-col-md-12 flex-col-sm-12 text-center content-box" style={{maxWidth: '928px', marginLeft: 'auto', marginRight: 'auto',}}>
							<div className="content-header bulleted">
								<h2 className="content-title bulleted">EV range (2011 - 2022)</h2>
							</div>
							<div className="inner-content bulleted">

								<div className="content single chart-title">
									{/*<p className="content-subtitle bulleted">Electric vehicles: longer range and more cars on the market</p>*/}
									{/*<p className="content-undersubtitle bulleted">Each dot is one model of electric car. The median is shown in red.</p>*/}
									<p className="content-subtitle bulleted">Each dot is one model of electric car. The median is shown in red.</p>
								</div>

								<div className="content">
									<div id="event-tiles">
										<img className="tile tile1" src={EVRangeMobile} alt="A dot chart showing increasing number of electric vehicles and increasing range in miles from 2011 to 2022. " aria-label="A dot chart showing increasing number of electric vehicles and increasing range in miles from 2011 to 2022. "/>
									</div>
									<div className="source">
										<p>Source: <a onClick={()=>fireTag('A1','u.s. environmental protection agency/hannah ritchie')} target="_blank" href="http://hannahritchie.com/chart-ev-range/?fireglass_rsn=true" rel="noreferrer" data-click-listener="true">U.S. Environmental Protection Agency/Hannah Ritchie</a></p>
										<p>Only all-electric vehicles are included.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>


				<div className="flex-row">
					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro">

						<p>
							<strong>A downshift in prices:</strong> The AAA <a onClick={()=>fireTag('A1', 'survey')} target="_blank" href="https://info.oregon.aaa.com/aaa-research-25-of-americans-say-theyd-buy-an-ev-for-their-next-auto-purchase/" rel="noreferrer" data-click-listener="true">survey</a> found consumers are concerned with higher EV purchase prices compared to traditional gas-powered vehicles. However, lower manufacturer’s suggested retail prices and new government incentives are helping to make EVs more affordable.
						</p>

						<p>According to <a onClick={()=>fireTag('A1', 'kelley blue book')} target="_blank" href="https://www.kbb.com/car-news/average-new-car-price-holding-steady-under-sticker/" rel="noreferrer" data-click-listener="true">Kelley Blue Book</a>, the average price of an EV fell by more than $9,000 between May 2022 and May 2023. This <a onClick={()=>fireTag('A1', 'represents')} target="_blank" href="https://mediaroom.kbb.com/2022-06-09-New-Vehicle-Prices-Flirt-with-Record-High-in-May,-According-to-Kelley-Blue-Book,-as-Luxury-Share-Remains-Strong" rel="noreferrer" data-click-listener="true">represents</a> a nearly 14% decline. During the same period, the purchase price of new cars overall increased by 3% year-over-year.
						</p>


						<p><strong>Investment in the domestic supply chain:</strong> The increased demand for EVs and IRA incentives are prompting new investments to scale production and strengthen EV supply chains.</p>

						<p>EVs must meet specific “Made in America” <a onClick={()=>fireTag('A1', 'requirements')} target="_blank" href="https://www.irs.gov/credits-deductions/credits-for-new-clean-vehicles-purchased-in-2023-or-after" rel="noreferrer" data-click-listener="true">requirements</a> to be eligible for the consumer IRA tax credits. To expand the U.S. EV production <a onClick={()=>fireTag('A1', 'capacity')} target="_blank" href="https://www.iea.org/reports/global-ev-outlook-2022/executive-summary" rel="noreferrer" data-click-listener="true">capacity</a> beyond its 10% market share, the IRA and the Infrastructure Investments and Jobs Act provide at least <a onClick={()=>fireTag('A1', '$83 billion')} target="_blank" href="https://www.atlasevhub.com/data_story/210-billion-of-announced-investments-in-electric-vehicle-manufacturing-headed-for-the-u-s/" rel="noreferrer" data-click-listener="true">$83 billion</a> of loans, grants, and tax credits for the production of low- or zero-emission vehicles, batteries, or chargers.
						</p>

						<p>These conditions are resulting in an explosion of EV supply chain <a onClick={()=>fireTag('A1', 'investments')} target="_blank" href="https://www.charged-the-book.com/na-ev-supply-chain-map" rel="noreferrer" data-click-listener="true">investments</a>. As of publication, that includes:</p>

						<ul className="copy-list">
							<li>
								$55 billion in announced investments in the U.S., with battery cell production as the leading area of investment.
							</li>
							<li>
								More than 40,000 new jobs projected.
							</li>
						</ul>
					</div>
				</div>


				{/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>
			{/* Adobe retargeting tag */
			}
			{
				/*
				REMOVE TAG 

			<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}

			{
				modalOverlay && modalOverlay.open && (
					<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
				)
			}
		</>
	);
};

export default withRouter(EV);
